export default "__VITE_ASSET__eedb26c7__"